var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5605 25.9395L34.0605 21.4395C33.7792 21.1583 33.3977 21.0003 33 21.0003C32.6023 21.0003 32.2208 21.1583 31.9395 21.4395L18 35.379V42H24.621L38.5605 28.0605C38.8417 27.7792 38.9997 27.3977 38.9997 27C38.9997 26.6023 38.8417 26.2208 38.5605 25.9395ZM23.379 39H21V36.621L28.5 29.121L30.879 31.5L23.379 39ZM33 29.379L30.621 27L33 24.621L35.379 27L33 29.379ZM21 24V18H24V24H21ZM15 24V15H18V24H15ZM9 24V9H12V24H9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 42H3C2.20459 41.9992 1.44199 41.6829 0.879557 41.1204C0.31712 40.558 0.000794215 39.7954 0 39V3C0.000794215 2.20459 0.31712 1.44199 0.879557 0.879557C1.44199 0.31712 2.20459 0.000794215 3 0H27C27.7954 0.000794215 28.558 0.31712 29.1204 0.879557C29.6829 1.44199 29.9992 2.20459 30 3V18H27V3H3V39H12V42Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteBook);
export default __webpack_public_path__ + "static/media/noteBook.4c41fd3fa4ecae521e0c5ef23ec8544e.svg";
export { ForwardRef as ReactComponent };